import { SeverityLevel } from '@sentry/types';

import { logger } from './logger';

export const logMessage = (message: string, severity: SeverityLevel, extras?: Record<string, unknown>) => {
  logger[severity](message, { extra: extras });
};
